import layoutMiddleware from './layout'
import ui from './ui'

const middleware = [
  layoutMiddleware,
  ...ui
]

export default middleware
